import React from 'react';
import { Box } from '@chakra-ui/layout';
import { HTMLChakraProps } from '@chakra-ui/system';

export default function FieldLabel(props: HTMLChakraProps<'div'>) {
  return (
    <Box bg="blue.100" rounded="lg" px={{ base: 5, sm: 6 }} py={3} {...props} />
  );
}
